import React from 'react';
import { useSelector } from 'react-redux';

import { selectEmbeddedMode } from '../store/selectors/ui';

type EmbeddedModeProps = {
  display?: boolean;
  children: React.ReactNode;
};

export const EMBEDDED_MODES = ['rethink', 'buildoutCrm'];

export default function EmbeddedMode({ display = false, children }: EmbeddedModeProps) {
  const embeddedMode = useSelector(selectEmbeddedMode);
  const inEmbedded = EMBEDDED_MODES.includes(embeddedMode);

  if (inEmbedded && display || (!inEmbedded && !display)) {
    return (
      <>
        {children}
      </>
    );
  }

  return null;
}
